<template>
  <v-container fluid>
    <v-row no-gutters>
      <v-col cols="12" lg="6" sm="12">
        <v-card>
          <v-list-item>
            <v-list-item-avatar>
                <v-icon>mdi-cards</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
                <v-list-item-title class="headline">等級情報編集</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-card-text>
            <v-form ref="rank_form" v-model="valid" @submit.prevent>
              <v-text-field label="順番号" v-model="sequenceNumber" :rules="sequenceNumberRules" dense outlined>
                <template v-slot:append>
                  <v-chip small color="red" text-color="white"><strong>必須</strong></v-chip>
                </template>
              </v-text-field>
              <v-text-field label="等級名" v-model="rankName" :rules="rankNameRules" dense outlined>
                <template v-slot:append>
                  <v-chip small color="red" text-color="white"><strong>必須</strong></v-chip>
                </template>
              </v-text-field>
              <v-text-field label="日給" v-model="dailyPay" :rules="dailyPayRules" suffix="円/日" dense outlined>
                <template v-slot:append>
                  <v-chip small color="red" text-color="white"><strong>必須</strong></v-chip>
                </template>
              </v-text-field>
              <v-text-field label="時給" v-model="hourlyPay" :rules="hourlyPayRules" suffix="円/時" dense outlined>
                <template v-slot:append>
                  <v-chip small color="red" text-color="white"><strong>必須</strong></v-chip>
                </template>
              </v-text-field>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="grey lighten-1" class="mr-3" :to="{ name: 'RankMaster' }" depressed>キャンセル</v-btn>
            <v-btn color="primary" @click.prevent="checkDialog" :disabled="!valid" depressed>確認</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <v-row justify="center">
        <custom-dialog :maxWith="dialogMaxWith" :title="dialogTitle" :items="dialogItems" :drawer="dialogDrawer" visibleUpdate
          @updated="submit" @canceled="dialogCancel"/>
      </v-row>
  </v-container>
</template>

<script>
import { useAppInsights } from '@/plugins/application-insights';
import statusList from "@/helpers/const";
import CalcCommon from "@/helpers/calcCommon";
import RankApi from "@/api/rank-api";
import CustomDialog from "@/components/custom_ui/CustomDialog";
import Rule from "@/validation/rules";

export default {
  name: "RankMasterEdit",
  components: {
    CustomDialog
  },
  data: () => ({
    loading: false,
    //フォームの項目
    rankName: "",
    sequenceNumber: "",
    dailyPay: "",
    hourlyPay: "",

    // 更新ダイアログ
    dialogMaxWith: 500,
    dialogTitle: "",
    dialogItems: [],
    dialogDrawer: false,
    editId: null,

    // バリデーション
    valid: true,
    rankNameRules: Rule.rankNameRules,
    sequenceNumberRules: Rule.sequenceNumberRules,
    dailyPayRules: Rule.dailyPayRules,
    hourlyPayRules: Rule.hourlyPayRules
  }),
  created() {
    this.initialize();
  },
  watch: {
    sequenceNumber (value) { this.sequenceNumber = this.stringFormat(value); },
    dailyPay (value) {
        this.dailyPay = this.stringFormat(value);
        this.hourlyPay = Math.round(this.dailyPay / 8)
    },
    hourlyPay (value) { this.hourlyPay = this.stringFormat(value); },
  },
  methods: {
    isLoading() {
      this.loading = !this.loading;
      this.$emit("loading", this.loading);
    },
    initialize() {
        this.isLoading();
        this.rankApi = new RankApi();
        this.editId = this.$route.params.id;
        const promise = this.rankApi.info(this.editId);
        promise.then(response => {
            this.rankName = response.data.body.rank_info.name;
            this.sequenceNumber = response.data.body.rank_info.sequence_number;
            this.dailyPay = response.data.body.rank_info.daily_pay;
            this.hourlyPay = response.data.body.rank_info.hourly_pay;
        }).catch(error => {
            useAppInsights().trackException({exception: error});
            if (error.response) {
                if (error.response.data.status == statusList.status.authError) {
                    this.$emit('logoutConform');
                } else if(error.response.data.status == statusList.status.entityError) {
                    this.$emit("error",error.response.data.message);
                    this.$router.push({ name: "CategoryMaster" })
                } else {
                    this.$emit("error",error.response.data.message);
                }
            } else {
                this.$emit("error","サーバーエラーが発生しました。");
            }
        }).finally(() => {
            this.isLoading();
        });
    },
    stringFormat(value) {
        var result = value.toString()
        while (result.match(/[０-９]/g)) {
            result = result.replace(/[０-９]/g, function(s) {
            return String.fromCharCode(s.charCodeAt(0) - 65248);
            });
        }
        return result;
    },
    //更新ボタン押下時
    checkDialog() {
      this.dialogTitle = "更新しますか？";
      this.dialogItems = [
        { name: "順番号", value: this.sequenceNumber },
        { name: "等級名", value: this.rankName },
        { name: "日給", value: CalcCommon.addFigure(this.dailyPay) },
        { name: "時給", value: CalcCommon.addFigure(this.hourlyPay) }
      ];
      this.dialogDrawer = true;
    },
    dialogCancel() {
      this.dialogDrawer = false;
    },
    //ダイアログ登録ボタン押下時
    submit() {
      if (this.$refs.rank_form.validate()) {
        this.isLoading();
        const params = {
          name: this.rankName,
          sequence_number: this.sequenceNumber,
          daily_pay: this.dailyPay,
          hourly_pay: this.hourlyPay
        };
        const promise = this.rankApi.update(this.editId, params);
        promise.then(response => {
          this.$router.push({ name: 'RankMaster' });
          this.$emit("success", response.data.message);
        }).catch(error => {
          useAppInsights().trackException({exception: error});
          if (error.response) {
            if (error.response.data.status == statusList.status.authError) {
              this.dialogDrawer = false;
              this.$emit('logoutConform');
            } else {
              this.$emit("error",error.response.data.message);
            }
          } else {
            this.$emit("error","サーバーエラーが発生しました。");
          }
        }).finally(() => {
          this.isLoading();
        });
      }
    }
  }
};
</script>
